<template>
  <vs-popup class="customer-sample-order-create-popup"
            id="popup"
            title="UPDATE SUPPLIER SERVICE ORDER"
            @close="open = false"
            :active.sync="open"
            :buttons-hidden="true">
    <vx-card no-shadow>

      <ValidationObserver ref="form" v-slot="{ handleSubmit }">
        <form @submit.prevent="handleSubmit(onClickUpdateServiceOrder)" autocomplete="off">
          <div class="mb-3 vx-row">
            <div class="w-full vx-col md:w-2/3 md:mb-0">
              <vs-table :data="cartItems" stripe>
                <template slot="header">
                  <h3>
                  </h3>
                </template>
                <template slot="thead">
                  <vs-th width="20">SERVICE NAME</vs-th>
                  <vs-th width="20">SERVICE DESCRIPTION</vs-th>
                  <vs-th width="20">QUANTITY</vs-th>
                  <vs-th width="20">UNIT PRICE</vs-th>
                  <vs-th width="20">VAT AMOUNT (GBP)</vs-th>
                  <vs-th width="30">TOTAL Excl VAT (GBP)</vs-th>
<!--                  <vs-th width="30">Description</vs-th>-->
                  <!-- <vs-th width="20"></vs-th> -->
                </template>

                <template slot-scope="{data}">
                  <vs-tr :key="indextr" v-for="(tr, indextr) in data">

                    <vs-td :data="data[indextr].other_supplier_service_name">
                      {{ data[indextr].other_supplier_service_name }}
                    </vs-td>

                    <vs-td :data="data[indextr].description">
                      <ValidationProvider :vid="indextr+'description'" :name="indextr+'description'" rules="" v-slot="{ errors }">
                        <vs-textarea class="mb-0" v-model="data[indextr].description"  height="70px" />
                      </ValidationProvider>
                    </vs-td>

                    <vs-td :data="data[indextr].quantity">
                      <vs-input 
                        v-model="data[indextr].quantity" 
                        type="number"
                        class="w-full" 
                        min="0"
                        step="0"
                      />
                    </vs-td>

                    <vs-td :data="data[indextr].unit_price">
                      <vs-input 
                        v-model="data[indextr].unit_price" 
                        type="number"
                        class="w-full" 
                        min="0"
                        step="0.01"
                      />
                    </vs-td>

                    <vs-td :data="data[indextr].vat">
                      <vs-input 
                        v-model="data[indextr].vat" 
                        type="number"
                        class="w-full" 
                        min="0"
                        step="0.01"
                      />
                    </vs-td>

                    <vs-td :data="data[indextr].unit_price">
                      {{data[indextr].quantity ? (Number(data[indextr].unit_price) * data[indextr].quantity).toFixed(2) : '0.00'}}
                    </vs-td>

<!--                    <vs-td :data="data[indextr].description">-->
<!--                      {{ data[indextr].description }}-->
<!--                    </vs-td>-->

                    <!-- <vs-td :data="data[indextr].id">
                      <vx-tooltip class="" text="Remove from cart" position="left">
                        <vs-button @click="onClickRemoveFromCart(data[indextr].id, indextr)"
                                    size="small" color="danger" type="border" icon-pack="feather" icon="icon-delete">Remove</vs-button>
                      </vx-tooltip>
                    </vs-td> -->

                  </vs-tr>
                </template>
              </vs-table>
              <vx-card no-shadow class="mt-10">
                <span>
                  <div class="mb-3 vx-row">
                    <div class="vx-col">
                       <h3>Additional Cost</h3>
                    </div>
                  </div>
                  <div class="vx-row">
                    <div class="w-full vx-col">
                      <vs-button color="success" size="small" type="border" @click="addCost">Add</vs-button>
                    </div>
                  </div>

                  <div class="mt-8 mb-3 vx-row" v-for="(additional_cost, index) in additional_costs" :key="additional_cost.id">
                      <div class="w-full vx-col md:w-1/4 md:mb-0">
                        <ValidationProvider vid="name" name="name" rules="required" v-slot="{ errors }">
                          <small class="label">Name</small>
                          <vs-input v-model="additional_cost.name"  name="name" class="w-full" label="" :danger="!!errors[0]" :danger-text="errors[0]" val-icon-danger="icon-x" val-icon-pack="feather"/>
                        </ValidationProvider>
                      </div>
<!--                      <div class="w-full vx-col md:w-1/4 md:mb-0">-->
<!--                        <ValidationProvider vid="type" name="type" rules="required" v-slot="{ errors }">-->
<!--                          <small class="label">Type</small>-->
<!--                          <v-select :clearable="false" name="type" placeholder="Select Cost Type"-->
<!--                              v-model="additional_cost.type"-->
<!--                              :options="types" />-->
<!--                          <span class="text-sm text-danger">{{ errors[0] }}</span>-->
<!--                        </ValidationProvider>-->
<!--                      </div>-->
                      <div class="w-full vx-col md:w-1/4 md:mb-0">
                        <ValidationProvider vid="amount" name="amount" rules="" v-slot="{ errors }">
                          <small class="label">Amount (GBP)</small>
                          <vs-input v-model="additional_cost.amount"  name="amount" class="w-full" label="" :danger="!!errors[0]" :danger-text="errors[0]" val-icon-danger="icon-x" val-icon-pack="feather"/>
                        </ValidationProvider>
                      </div>
                    <div class="w-full vx-col md:w-1/4 md:mb-0">
                        <ValidationProvider vid="vat" name="vat" rules="" v-slot="{ errors }">
                          <small class="label">VAT (GBP)</small>
                          <vs-input v-model="additional_cost.vat"  name="vat" class="w-full" label="" :danger="!!errors[0]" :danger-text="errors[0]" val-icon-danger="icon-x" val-icon-pack="feather"/>
                        </ValidationProvider>
                      </div>
                      <div class="w-50 vx-col md:w-1/4 md:mb-0">
                        <vs-button @click="deleteCost(index)" class="mt-8 ml-3"
                                   size="small" color="danger" type="border" icon-pack="feather" icon="icon-delete"></vs-button>
                      </div>
                  </div>
                </span>
              </vx-card>
            </div>
              <div class="w-full vx-col md:w-1/3 md:mb-0">
              <vx-card>
                <span>
                  <div class="mb-3 vx-row">
                    <div class="w-full vx-col md:w-1/2 md:mb-0">
                      <ValidationProvider vid="line1" name="line1" rules="required" v-slot="{ errors }">
                        <small class="label">Address Line 1</small>
                        <vs-input v-model="createForm.line1"  name="line1" class="w-full" label="" :danger="!!errors[0]" :danger-text="errors[0]" val-icon-danger="icon-x" val-icon-pack="feather"/>
                      </ValidationProvider>
                    </div>
                    <div class="w-full vx-col md:w-1/2 md:mb-0">
                      <ValidationProvider vid="line2" name="line2" rules="" v-slot="{ errors }">
                        <small class="label">Address Line 2</small>
                        <vs-input v-model="createForm.line2"  name="line2" class="w-full" label="" :danger="!!errors[0]" :danger-text="errors[0]" val-icon-danger="icon-x" val-icon-pack="feather"/>
                      </ValidationProvider>
                    </div>
                  </div>

                  <div class="mb-3 vx-row">
                    <div class="w-full vx-col md:w-1/2 md:mb-0">
                      <ValidationProvider vid="line3" name="line3" rules="" v-slot="{ errors }">
                        <small class="label">Address Line 3</small>
                        <vs-input v-model="createForm.line3"  name="line3" class="w-full" label="" :danger="!!errors[0]" :danger-text="errors[0]" val-icon-danger="icon-x" val-icon-pack="feather"/>
                      </ValidationProvider>
                    </div>
                    <div class="w-full vx-col md:w-1/2 md:mb-0">
                      <ValidationProvider vid="town_state" name="town_state" rules="required" v-slot="{ errors }">
                        <small class="label">Town / State</small>
                        <vs-input v-model="createForm.town_state"  name="town_state" class="w-full" label="" :danger="!!errors[0]" :danger-text="errors[0]" val-icon-danger="icon-x" val-icon-pack="feather"/>
                      </ValidationProvider>
                    </div>
                  </div>

                  <div class="mb-3 vx-row">
                    <div class="w-full vx-col md:w-1/2 md:mb-0">
                      <ValidationProvider vid="post_code" name="post_code" rules="required" v-slot="{ errors }">
                        <small class="label">Postal Code</small>
                        <vs-input v-model="createForm.post_code"  name="post_code" class="w-full" label="" :danger="!!errors[0]" :danger-text="errors[0]" val-icon-danger="icon-x" val-icon-pack="feather"/>
                      </ValidationProvider>
                    </div>
                    <div class="w-full vx-col md:w-1/2 md:mb-0">
                      <ValidationProvider vid="country" name="country" rules="required" v-slot="{ errors }">
                        <small class="label">Country</small>
                        <v-select :filter-by="myFilter" :clearable="false" name="country" placeholder=""
                          label="name" v-model="createForm.country" :reduce="option => option.name"
                          :options="countryCodes" :dir="$vs.rtl ? 'rtl' : 'ltr'"/>
                      </ValidationProvider>
                    </div>
                  </div>
                  <div class="vx-row mb-3">
                    <div class="vx-col md:w-1/2 w-full md:mb-0">
                      <ValidationProvider vid="sage_department" name="sage_department" rules="required" v-slot="{errors}">
                        <small class="label">Sage Department</small>
                          <v-select :filter-by="myFilter" :clearable="false" name="sage_department" placeholder=""
                            label="name" v-model="createForm.sage_department_id" :reduce="option => option.id"
                            :options="sage_departments" :dir="$vs.rtl ? 'rtl' : 'ltr'"/>
                          <span class="text-danger text-sm">{{ errors[0] }}</span>
                      </ValidationProvider>
                    </div>
                  <div class="vx-col md:w-1/2 w-full md:mb-0">
                    <ValidationProvider vid="region" name="region" rules="required" v-slot="{errors}">
                      <small class="label">Region</small>
                        <v-select :filter-by="myFilter" :clearable="false" name="region" placeholder=""
                            label="name" v-model="createForm.region_id" :reduce="option => option.id"
                            :options="regions" :dir="$vs.rtl ? 'rtl' : 'ltr'"/>
                    <span class="text-danger text-sm">{{ errors[0] }}</span>
                   </ValidationProvider>
                  </div>
                  </div>
                  <div class="vx-row mb-3">
                    <div class="vx-col md:w-full w-full md:mb-0">
                    <ValidationProvider vid="required_by" name="required_by" rules="required" v-slot="{ errors }">
                        <small class="label">Required By Date</small>
                        <flat-pickr class="w-full"
                                    style="display: none"
                                    :config="{ dateFormat: 'd/m/Y'}"
                                    v-model="createForm.required_by"
                                    placeholder="Choose Date"
                        />
                      <flat-pickr class="w-full"
                                  :config="{ dateFormat: 'd/m/Y'}"
                                  v-model="createForm.required_by"
                                  placeholder="Choose Date"
                      />
                        <span class="text-danger text-sm">{{ errors[0] }}</span>
                    </ValidationProvider>
              </div>
                  </div>
                </span>

                <div class="mb-3 vx-row">
                  <div class="w-full vx-col">
                    <ValidationProvider vid="delivery_instruction" name="delivery_instruction" rules="" v-slot="{ errors }">
                      <small class="label">Delivery Instructions</small>
                      <vs-textarea class="mb-0" v-model="createForm.delivery_instruction" height="80px" />
                      <span class="mt-0 text-xs text-danger">{{ errors[0] }}</span>
                    </ValidationProvider>
                  </div>
                </div>
                <div class="mb-3 vx-row">
                  <div class="w-full vx-col">
                    <ValidationProvider vid="note" name="note" rules="" v-slot="{ errors }">
                      <small class="label">Special Note</small>
                      <vs-textarea class="mb-0" v-model="createForm.note" height="120px" />
                      <span class="mt-0 text-xs text-danger">{{ errors[0] }}</span>
                    </ValidationProvider>
                  </div>
                </div>
              </vx-card>
              </div>
          </div>
          <!-- Save & Reset Button -->
          <div class="flex flex-wrap items-center justify-end mt-8">
            <vs-button button="submit" class="mt-2 ml-auto">Update Order</vs-button>
            <vs-button @click="open =false" class="mt-2 ml-4" type="border" color="warning">Cancel</vs-button>
          </div>
        </form>
      </ValidationObserver>
    </vx-card>
  </vs-popup>
</template>

<script>
  import { RepositoryFactory } from '@/repository/RepositoryFactory'
  const OtherSupplierRepository = RepositoryFactory.get('other_supplier')
  const SupplierManufactureRepository = RepositoryFactory.get('supplierManufacture');
  const RegionsRepository = RepositoryFactory.get('regions');
  const SageSettingsRepository = RepositoryFactory.get('sage_settings');

  import { XIcon } from 'vue-feather-icons'
  import vSelect from 'vue-select'
  import SuccessMessage from '@/mixins/SuccessMessage'
  import ErrorMessages from '@/mixins/ErrorMessages'
  import flatPickr from 'vue-flatpickr-component'

  function initialState() {
    return {
      open: false,
      id: '',
      supplier_id: '',
      createForm: {

      },
      isCreateFromMainMenu: false,
      cartItems: [],
      additional_costs: [],
      countryCodes: [],
      types: [ 'percent', 'sum', 'subtract' ],
      sage_departments:[],
      regions:[],
    }
  }

  export default {
    name: 'OtherSupplierOrderPopUp',
    data () {
      return initialState()
    },
    methods:{
      async openPopup (id, supplier_id) {
        try {
          await Object.assign(this.$data, initialState())
          this.id = id
          this.supplier_id = supplier_id
          await this.getSupplierServiceOrder()
          await this.fetchCountryCodes()
          await this.getSageDepartments()
          await this.getRegions()
          this.open = true;
        } catch (error) {

        }
      },
       async fetchCountryCodes() {
        this.$vs.loading()
        try {
          this.countryCodes = (await SupplierManufactureRepository.getCountryCodes()).data.data;
        } catch (e) {
          this.convertAndNotifyError(e)
          this.open = false
        }
        this.$vs.loading.close()
      },
      async onClickUpdateServiceOrder () {
        const vue = this;
        this.$vs.loading()
        try {
          const payload = {
            line1: this.createForm.line1,
            line2: this.createForm.line2,
            line3: this.createForm.line3,
            town_state: this.createForm.town_state,
            post_code: this.createForm.post_code,
            country: this.createForm.country,
            delivery_instruction: this.createForm.delivery_instruction,
            note:this.createForm.note,
            required_by:this.createForm.required_by,
            sage_department_id: this.createForm.sage_department_id,
            region_id: this.createForm.region_id,
            order_items: this.cartItems.map((x) => {
                  return {
                    other_supplier_service_id: x.other_supplier_service_id,
                    quantity: x.quantity,
                    unit_price: Number(x.unit_price).toFixed(2),
                    vat: x.vat ? Number(x.vat).toFixed(2) : '0.00',
                    description: x.description,
                  }
                }),
            additional_cost: this.additional_costs.map((n) => {
              return { name: n.name, amount: Number(n.amount).toFixed(2), vat: n.vat ? Number(n.vat).toFixed(2) : '0.00' }
            }),
          }
          await OtherSupplierRepository.updateSupplierServicesOrder(this.id, payload)
          this.showSuccessMessage('Service order update successfully')
          await vue.$parent.refreshData()
          this.open = false;
        }catch (e) {
          this.$vs.loading.close()
          this.convertAndNotifyError(e)
        }
        this.$vs.loading.close()
      },
      async getSupplierServiceOrder() {
        this.$vs.loading()
        const {data} = await OtherSupplierRepository.getSupplierServiceOrder(this.id)
        this.createForm =  data.data
        this.cartItems =  data.data.order_items
        this.additional_costs =  data.data.additional_cost
        this.createForm.region_id = data.data.region.id
        this.createForm.sage_department_id = data.data.sage_department.id
        this.$vs.loading.close()
      },
      async getSageDepartments(){
        this.$vs.loading()
        const {data} = await SageSettingsRepository.getListOfSageDepartments('','','',0)
        this.sage_departments =  data.data
        this.$vs.loading.close()
      },
      async getRegions(){
        this.$vs.loading()
        const {data} = await RegionsRepository.getListOfRegions()
        this.regions =  data.data
        this.$vs.loading.close()
      },
      addCost(){
        this.additional_costs.push({ name: '',type:'',amount:'' });
      },
      deleteCost: function (index) {
        this.additional_costs.splice(index, 1);
      },
      myFilter: (option, label, search) => {
        let temp = search.toLowerCase();
        return option.name.toLowerCase().indexOf(temp) > -1 ||
          option.isd_code.toLowerCase().indexOf(temp) > -1
      },
    },
    async mounted () {

    },
    computed: {

    },
    components: {
      'v-select': vSelect,
      XIcon,
      flatPickr,
    },
    mixins: [SuccessMessage, ErrorMessages],
  }
</script>

<style scoped>
  .customer-sample-order-create-popup >>> .vs-popup {
    /*min-height: 50% !important;*/
    min-width: 80% !important;
  }
  .loader {
    text-align: center;
    color: #bbbbbb;
  }

</style>
